// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let Scroll = require("../../../reason/common/Scroll/Scroll.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let PageTitle = require("../../../reason/common/PageTitle.bs.js");
let PageViews = require("../../../reason/PageViews.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let LoggedInAgent = require("../../../reason/common/UserSession/LoggedInAgent.bs.js");
let MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let BuyerNeedSearchResult = require("./BuyerNeedSearchResult.bs.js");
let VisuallyHidden = require("@reach/visually-hidden").default;
let RentalNeedSearchResult = require("./RentalNeedSearchResult.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SearchPagesSharedComponents = require("../../common/SearchPagesSharedComponents.bs.js");
let ClientNeedsPageRelayControls = require("./ClientNeedsPageRelayControls.bs.js");
let ClientNeedsPageRelayQueryParams = require("./ClientNeedsPageRelayQueryParams.bs.js");
let ClientNeedsPageRelayQuery_graphql = require("../../../__generated__/ClientNeedsPageRelayQuery_graphql.bs.js");
let ClientNeedsPageRelaySharedComponents = require("./ClientNeedsPageRelaySharedComponents.bs.js");
let ClientNeedsPageRelayBuying_query_graphql = require("../../../__generated__/ClientNeedsPageRelayBuying_query_graphql.bs.js");
let ClientNeedsPageRelayRefetchQuery_graphql = require("../../../__generated__/ClientNeedsPageRelayRefetchQuery_graphql.bs.js");
let ClientNeedsPageRelayRental_query_graphql = require("../../../__generated__/ClientNeedsPageRelayRental_query_graphql.bs.js");
let ClientNeedsPageRelayWrapperQuery_graphql = require("../../../__generated__/ClientNeedsPageRelayWrapperQuery_graphql.bs.js");
let ClientNeedsPageRelayRentalRefetchQuery_graphql = require("../../../__generated__/ClientNeedsPageRelayRentalRefetchQuery_graphql.bs.js");
let ClientNeedsPageRelay_recordSearchEventMutation_graphql = require("../../../__generated__/ClientNeedsPageRelay_recordSearchEventMutation_graphql.bs.js");

let convertVariables = ClientNeedsPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = ClientNeedsPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = ClientNeedsPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, ClientNeedsPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, ClientNeedsPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(ClientNeedsPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(ClientNeedsPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(ClientNeedsPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(ClientNeedsPageRelayQuery_graphql.node, convertVariables);

let Query_buyerNeedV5FilterableStatus_decode = ClientNeedsPageRelayQuery_graphql.Utils.buyerNeedV5FilterableStatus_decode;

let Query_buyerNeedV5FilterableStatus_fromString = ClientNeedsPageRelayQuery_graphql.Utils.buyerNeedV5FilterableStatus_fromString;

let Query_forSalePropertyTypeEnumV5_decode = ClientNeedsPageRelayQuery_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let Query_forSalePropertyTypeEnumV5_fromString = ClientNeedsPageRelayQuery_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let Query_rentalNeedV5FilterableStatus_decode = ClientNeedsPageRelayQuery_graphql.Utils.rentalNeedV5FilterableStatus_decode;

let Query_rentalNeedV5FilterableStatus_fromString = ClientNeedsPageRelayQuery_graphql.Utils.rentalNeedV5FilterableStatus_fromString;

let Query_rentalPropertyTypeEnumV5_decode = ClientNeedsPageRelayQuery_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let Query_rentalPropertyTypeEnumV5_fromString = ClientNeedsPageRelayQuery_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let Query = {
  buyerNeedV5FilterableStatus_decode: Query_buyerNeedV5FilterableStatus_decode,
  buyerNeedV5FilterableStatus_fromString: Query_buyerNeedV5FilterableStatus_fromString,
  forSalePropertyTypeEnumV5_decode: Query_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: Query_forSalePropertyTypeEnumV5_fromString,
  rentalNeedV5FilterableStatus_decode: Query_rentalNeedV5FilterableStatus_decode,
  rentalNeedV5FilterableStatus_fromString: Query_rentalNeedV5FilterableStatus_fromString,
  rentalPropertyTypeEnumV5_decode: Query_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: Query_rentalPropertyTypeEnumV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let convertFragment = ClientNeedsPageRelayBuying_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ClientNeedsPageRelayBuying_query_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ClientNeedsPageRelayBuying_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ClientNeedsPageRelayBuying_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ClientNeedsPageRelayBuying_query_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = ClientNeedsPageRelayRefetchQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = ClientNeedsPageRelayRefetchQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(ClientNeedsPageRelayBuying_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

let BuyingQueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable
};

let convertFragment$1 = ClientNeedsPageRelayRental_query_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ClientNeedsPageRelayRental_query_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ClientNeedsPageRelayRental_query_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ClientNeedsPageRelayRental_query_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ClientNeedsPageRelayRental_query_graphql.node, convertFragment$1, fRef);
}

let makeRefetchVariables$1 = ClientNeedsPageRelayRentalRefetchQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables$1 = ClientNeedsPageRelayRentalRefetchQuery_graphql.Internal.convertVariables;

function useRefetchable$1(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(ClientNeedsPageRelayRental_query_graphql.node, convertFragment$1, convertRefetchVariables$1, fRef);
}

let RentalQueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1,
  makeRefetchVariables: makeRefetchVariables$1,
  convertRefetchVariables: convertRefetchVariables$1,
  useRefetchable: useRefetchable$1
};

let convertVariables$1 = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Internal.convertVariables;

let convertResponse$1 = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, ClientNeedsPageRelay_recordSearchEventMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$3 = RescriptRelay_Mutation.useMutation(convertVariables$1, ClientNeedsPageRelay_recordSearchEventMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let RecordEventMutation_buyerNeedV5FilterableStatus_decode = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Utils.buyerNeedV5FilterableStatus_decode;

let RecordEventMutation_buyerNeedV5FilterableStatus_fromString = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Utils.buyerNeedV5FilterableStatus_fromString;

let RecordEventMutation_forSalePropertyTypeEnumV5_decode = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let RecordEventMutation_forSalePropertyTypeEnumV5_fromString = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let RecordEventMutation_rentalNeedV5FilterableStatus_decode = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Utils.rentalNeedV5FilterableStatus_decode;

let RecordEventMutation_rentalNeedV5FilterableStatus_fromString = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Utils.rentalNeedV5FilterableStatus_fromString;

let RecordEventMutation_rentalPropertyTypeEnumV5_decode = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let RecordEventMutation_rentalPropertyTypeEnumV5_fromString = ClientNeedsPageRelay_recordSearchEventMutation_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let RecordEventMutation = {
  buyerNeedV5FilterableStatus_decode: RecordEventMutation_buyerNeedV5FilterableStatus_decode,
  buyerNeedV5FilterableStatus_fromString: RecordEventMutation_buyerNeedV5FilterableStatus_fromString,
  forSalePropertyTypeEnumV5_decode: RecordEventMutation_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: RecordEventMutation_forSalePropertyTypeEnumV5_fromString,
  rentalNeedV5FilterableStatus_decode: RecordEventMutation_rentalNeedV5FilterableStatus_decode,
  rentalNeedV5FilterableStatus_fromString: RecordEventMutation_rentalNeedV5FilterableStatus_fromString,
  rentalPropertyTypeEnumV5_decode: RecordEventMutation_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: RecordEventMutation_rentalPropertyTypeEnumV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation,
  use: use$3
};

function ClientNeedsPageRelay$Page(props) {
  let initiallySelectedAreas = props.initiallySelectedAreas;
  let match = ClientNeedsPageRelayQueryParams.use();
  let params = match[0];
  let match$1 = React.useState(() => ClientNeedsPageRelayQueryParams.Params.transformParamsForApi(params));
  let initialParams = match$1[0];
  let match$2 = React.useState(() => initiallySelectedAreas);
  let selectedAreas = match$2[0];
  let match$3 = React.useState(() => selectedAreas);
  let areas = match$3[0].map(v => v.id);
  let data = use({
    after: initialParams.after,
    areaIds: areas.length !== 0 ? areas : undefined,
    before: initialParams.before,
    buyerNeedPropertyTypes: initialParams.buyerNeedPropertyTypes,
    buyerNeedStatuses: initialParams.buyerNeedStatuses,
    first: initialParams.first,
    keywords: initialParams.keywords,
    last: initialParams.last,
    maxPrice: initialParams.maxPrice,
    minPrice: initialParams.minPrice,
    rentalMode: initialParams.rentalMode,
    rentalNeedPropertyTypes: initialParams.rentalNeedPropertyTypes,
    rentalNeedStatuses: initialParams.rentalNeedStatuses
  }, undefined, undefined, undefined);
  let match$4 = React.useTransition();
  let startTransition = match$4[1];
  let isRefetching = match$4[0];
  let match$5 = useRefetchable(data.fragmentRefs);
  let refetchBuying = match$5[1];
  let buyingData = match$5[0];
  let match$6 = useRefetchable$1(data.fragmentRefs);
  let refetchRental = match$6[1];
  let rentalData = match$6[0];
  let match$7 = use$3();
  let recordSearchEvent = match$7[0];
  let page = React.useMemo(() => PageViews.Page.makeBuyerNeedsPage(), []);
  PageViews.useRecordPageView(page);
  let recordSearchEvent$1 = params => {
    recordSearchEvent({
      input: {
        after: params.after,
        areaIds: params.areaIds,
        before: params.before,
        buyerNeedPropertyTypes: params.buyerNeedPropertyTypes,
        buyerNeedStatuses: params.buyerNeedStatuses,
        keywords: params.keywords,
        maxBeds: params.maxBeds,
        maxPrice: params.maxPrice,
        minBeds: params.minBeds,
        minPrice: params.minPrice,
        occurredAt: Scalars.DateTime.fromJsDate(new Date()),
        rentalMode: params.rentalMode,
        rentalNeedPropertyTypes: params.rentalNeedPropertyTypes,
        rentalNeedStatuses: params.rentalNeedStatuses
      }
    }, undefined, undefined, undefined, undefined, undefined, undefined);
  };
  React.useEffect(() => {
    recordSearchEvent$1(initialParams);
  }, [initialParams]);
  let refetch = (modeOpt, after, before, paramSetter) => {
    let mode = modeOpt !== undefined ? modeOpt : "replace";
    let newrecord = {...paramSetter(ClientNeedsPageRelayQueryParams.getCurrentParams())};
    newrecord.before = before;
    newrecord.after = after;
    let paramsReadyForApi = ClientNeedsPageRelayQueryParams.Params.transformParamsForApi(newrecord);
    recordSearchEvent$1(paramsReadyForApi);
    Scroll.scrollToTop();
    if (paramsReadyForApi.rentalMode) {
      startTransition(() => {
        refetchRental(makeRefetchVariables$1(Primitive_option.some(paramsReadyForApi.after), Primitive_option.some(paramsReadyForApi.areaIds), Primitive_option.some(paramsReadyForApi.before), Primitive_option.some(paramsReadyForApi.first), Primitive_option.some(paramsReadyForApi.keywords), Primitive_option.some(paramsReadyForApi.last), Primitive_option.some(paramsReadyForApi.maxPrice), Primitive_option.some(paramsReadyForApi.minPrice), true, Primitive_option.some(paramsReadyForApi.rentalNeedPropertyTypes), Primitive_option.some(paramsReadyForApi.rentalNeedStatuses)), undefined, undefined);
      });
    } else {
      startTransition(() => {
        refetchBuying(makeRefetchVariables(Primitive_option.some(paramsReadyForApi.after), Primitive_option.some(paramsReadyForApi.areaIds), Primitive_option.some(paramsReadyForApi.before), Primitive_option.some(paramsReadyForApi.buyerNeedPropertyTypes), Primitive_option.some(paramsReadyForApi.buyerNeedStatuses), Primitive_option.some(paramsReadyForApi.first), Primitive_option.some(paramsReadyForApi.keywords), Primitive_option.some(paramsReadyForApi.last), Primitive_option.some(paramsReadyForApi.maxPrice), Primitive_option.some(paramsReadyForApi.minPrice), false), undefined, undefined);
      });
    }
    ClientNeedsPageRelayQueryParams.setQueryParamsInURL(mode, param => newrecord);
  };
  let match$8 = params.rentalMode;
  let match$9 = rentalData.searchRentalNeeds;
  let match$10 = buyingData.searchBuyerNeeds;
  let totalCount;
  if (match$8) {
    if (match$9 !== undefined) {
      let totalCount$1 = match$9.totalCount;
      totalCount = totalCount$1 !== undefined ? totalCount$1 : 0;
    } else {
      totalCount = 0;
    }
  } else if (match$10 !== undefined) {
    let totalCount$2 = match$10.totalCount;
    totalCount = totalCount$2 !== undefined ? totalCount$2 : 0;
  } else {
    totalCount = 0;
  }
  let tmp;
  if (params.rentalMode) {
    let match$11 = rentalData.searchRentalNeeds;
    let rentalItems;
    if (match$11 !== undefined) {
      let edges = match$11.edges;
      rentalItems = edges !== undefined ? Stdlib_Array.filterMap(edges, e => {
          if (e !== undefined) {
            return e.node;
          }
        }) : [];
    } else {
      rentalItems = [];
    }
    let tmp$1;
    if (isRefetching) {
      tmp$1 = JsxRuntime.jsx(Loader.make, {});
    } else if (rentalItems.length !== 0) {
      let match$12 = rentalData.searchRentalNeeds;
      let prevCursor;
      if (match$12 !== undefined) {
        let match$13 = match$12.pageInfo;
        if (match$13.hasPreviousPage) {
          let startCursor = match$13.startCursor;
          prevCursor = startCursor !== undefined ? startCursor : undefined;
        } else {
          prevCursor = undefined;
        }
      } else {
        prevCursor = undefined;
      }
      let match$14 = rentalData.searchRentalNeeds;
      let nextCursor;
      if (match$14 !== undefined) {
        let match$15 = match$14.pageInfo;
        let endCursor = match$15.endCursor;
        nextCursor = endCursor !== undefined && match$15.hasNextPage ? endCursor : undefined;
      } else {
        nextCursor = undefined;
      }
      tmp$1 = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("ul", {
              children: rentalItems.map(item => JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(RentalNeedSearchResult.make, {
                  rentalNeed: item.fragmentRefs
                }),
                className: "col-span-1 contents"
              }, item.id)),
              className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4"
            }),
            className: "flex flex-col gap-4"
          }),
          JsxRuntime.jsx(ClientNeedsPageRelaySharedComponents.PaginationBox.make, {
            refetch: refetch,
            prevCursor: prevCursor,
            nextCursor: nextCursor,
            params: params
          })
        ],
        className: "flex flex-col gap-6"
      });
    } else {
      tmp$1 = JsxRuntime.jsx(SearchPagesSharedComponents.NoMatches.make, {
        text: "No client needs match your search right now."
      });
    }
    tmp = JsxRuntime.jsx("div", {
      children: tmp$1
    });
  } else {
    let match$16 = buyingData.searchBuyerNeeds;
    let buyingItems;
    if (match$16 !== undefined) {
      let edges$1 = match$16.edges;
      buyingItems = edges$1 !== undefined ? Stdlib_Array.filterMap(edges$1, e => Stdlib_Option.map(e, e => e.node)) : [];
    } else {
      buyingItems = [];
    }
    if (isRefetching) {
      tmp = JsxRuntime.jsx(Loader.make, {});
    } else if (buyingItems.length !== 0) {
      let match$17 = buyingData.searchBuyerNeeds;
      let prevCursor$1;
      if (match$17 !== undefined) {
        let match$18 = match$17.pageInfo;
        if (match$18.hasPreviousPage) {
          let startCursor$1 = match$18.startCursor;
          prevCursor$1 = startCursor$1 !== undefined ? startCursor$1 : undefined;
        } else {
          prevCursor$1 = undefined;
        }
      } else {
        prevCursor$1 = undefined;
      }
      let match$19 = buyingData.searchBuyerNeeds;
      let nextCursor$1;
      if (match$19 !== undefined) {
        let match$20 = match$19.pageInfo;
        let endCursor$1 = match$20.endCursor;
        nextCursor$1 = endCursor$1 !== undefined && match$20.hasNextPage ? endCursor$1 : undefined;
      } else {
        nextCursor$1 = undefined;
      }
      tmp = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(SearchPagesSharedComponents.ResultsInfo.make, {
                text: "Showing broadcast client needs only",
                helperIconText: "Add your sellers to get matched with quiet buyers"
              }),
              JsxRuntime.jsx("ul", {
                children: buyingItems.map(item => JsxRuntime.jsx("li", {
                  children: JsxRuntime.jsx(BuyerNeedSearchResult.make, {
                    buyerNeed: item.fragmentRefs
                  }),
                  className: "col-span-1 contents"
                }, item.id)),
                className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4"
              })
            ],
            className: "flex flex-col gap-4"
          }),
          JsxRuntime.jsx(ClientNeedsPageRelaySharedComponents.PaginationBox.make, {
            refetch: refetch,
            prevCursor: prevCursor$1,
            nextCursor: nextCursor$1,
            params: params
          })
        ],
        className: "flex flex-col gap-6"
      });
    } else {
      tmp = JsxRuntime.jsx(SearchPagesSharedComponents.NoMatches.make, {
        text: "No client needs match your search right now."
      });
    }
  }
  return JsxRuntime.jsxs(MarkupHelpers.Container.make, {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: "Client needs"
      }),
      JsxRuntime.jsx(VisuallyHidden, {
        children: "Client needs on TAN",
        _as: "h1"
      }),
      JsxRuntime.jsx(ClientNeedsPageRelayControls.make, {
        selectedAreas: selectedAreas,
        totalCount: totalCount,
        isRefetching: isRefetching,
        refetch: refetch,
        setSelectedAreas: match$2[1]
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(React.Suspense, {
          children: tmp,
          fallback: JsxRuntime.jsx(Loader.make, {})
        }),
        className: "py-4"
      })
    ]
  });
}

let Page = {
  RecordEventMutation: RecordEventMutation,
  make: ClientNeedsPageRelay$Page
};

let convertVariables$2 = ClientNeedsPageRelayWrapperQuery_graphql.Internal.convertVariables;

let convertResponse$2 = ClientNeedsPageRelayWrapperQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = ClientNeedsPageRelayWrapperQuery_graphql.Internal.convertWrapRawResponse;

let use$4 = RescriptRelay_Query.useQuery(convertVariables$2, ClientNeedsPageRelayWrapperQuery_graphql.node, convertResponse$2);

let useLoader$1 = RescriptRelay_Query.useLoader(convertVariables$2, ClientNeedsPageRelayWrapperQuery_graphql.node, prim => prim);

let usePreloaded$1 = RescriptRelay_Query.usePreloaded(ClientNeedsPageRelayWrapperQuery_graphql.node, convertResponse$2, prim => prim);

let fetch$1 = RescriptRelay_Query.fetch(ClientNeedsPageRelayWrapperQuery_graphql.node, convertResponse$2, convertVariables$2);

let fetchPromised$1 = RescriptRelay_Query.fetchPromised(ClientNeedsPageRelayWrapperQuery_graphql.node, convertResponse$2, convertVariables$2);

let retain$1 = RescriptRelay_Query.retain(ClientNeedsPageRelayWrapperQuery_graphql.node, convertVariables$2);

let WrapperQuery = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  use: use$4,
  useLoader: useLoader$1,
  usePreloaded: usePreloaded$1,
  fetch: fetch$1,
  fetchPromised: fetchPromised$1,
  retain: retain$1
};

function ClientNeedsPageRelay$WithLoggedInAgent(props) {
  let match = ClientNeedsPageRelayQueryParams.use();
  let params = match[0];
  let match$1 = React.useState(() => Stdlib_Option.getOr(params.areaIds, []));
  let initiallySelectedAreaIds = match$1[0];
  let shouldFetchAreas = initiallySelectedAreaIds.length !== 0;
  let data = use$4({
    areaIds: initiallySelectedAreaIds,
    fetchAreas: shouldFetchAreas
  }, shouldFetchAreas ? "store-or-network" : "store-only", undefined, undefined);
  let initiallySelectedAreas = Stdlib_Array.keepSome(Stdlib_Option.getOr(data.areas, []));
  return JsxRuntime.jsx(ClientNeedsPageRelay$Page, {
    initiallySelectedAreas: initiallySelectedAreas.map(v => ({
      id: v.id,
      label: v.label
    }))
  });
}

let WithLoggedInAgent = {
  make: ClientNeedsPageRelay$WithLoggedInAgent
};

function ClientNeedsPageRelay$default(props) {
  return JsxRuntime.jsx(LoggedInAgent.Provider.make, {
    children: JsxRuntime.jsx(ClientNeedsPageRelay$WithLoggedInAgent, {})
  });
}

let QueryParams;

let $$default = ClientNeedsPageRelay$default;

exports.QueryParams = QueryParams;
exports.Query = Query;
exports.BuyingQueryFragment = BuyingQueryFragment;
exports.RentalQueryFragment = RentalQueryFragment;
exports.Page = Page;
exports.WrapperQuery = WrapperQuery;
exports.WithLoggedInAgent = WithLoggedInAgent;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
